import React from 'react';
import {useTranslation} from "react-i18next";
import MenuItem from "./MenuItem";
import Icon from "./Sidebar/SidebarIcon";

export const DashboardMenuItem = ({ pathName }) => {
    const {t} = useTranslation();

    return (
        <MenuItem
            to="/dashboard"
            active={pathName === 'dashboard'}
            startIcon={<Icon type={pathName === 'dashboard' ? 'homeActive' : 'home'} />}
        >
            {t('dashboard')}
        </MenuItem>
    )
}

export const ChargePointsMenuItem = ({ pathName }) => (
    <MenuItem
        to="/charge-points"
        active={pathName === 'charge-points'}
        startIcon={<Icon type={pathName === 'charge-points' ? 'stationsActive' : 'stations'} />}
    >
        Зарядные станции
    </MenuItem>
)

export const LocationsMenuItem = ({ pathName }) => {
    const {t} = useTranslation();

    return (
        <MenuItem
            to="/locations"
            active={pathName === 'locations'}
            startIcon={<Icon type={pathName === 'locations' ? 'mapMarkerActive' : 'mapMarker'} />}
        >
            {t('locations')}
        </MenuItem>
    )
}

export const MapMenuItem = ({ pathName }) => {
    const {t} = useTranslation();

    return (
        <MenuItem
            to="/map"
            active={pathName === 'map'}
            startIcon={<Icon type={pathName === 'map' ? 'mapActive' : 'map'} />}
        >
            {t('map')}
        </MenuItem>
    )
}

export const AspMenuItem = ({ pathName }) => (
    <MenuItem
        to="/anti-sanction-protection"
        active={pathName === 'anti-sanction-protection'}
        startIcon={<Icon type={pathName === 'anti-sanction-protection' ? 'antiSanctionProtectionActive' : 'antiSanctionProtection'} />}
    >
        Антисанкции. Версии
    </MenuItem>
)

export const ProfileMenuItem = ({ pathName }) => {
    const {t} = useTranslation();

    return (
        <MenuItem
            to="/settings/profile"
            active={pathName === 'settings'}
            startIcon={<Icon type={pathName === 'settings' ? 'settingsActive' : 'settings'} />}
        >
            {t('settings')}
        </MenuItem>
    )
}

export const StatisticsByDayMenuItem = ({ pathName }) => (
    <MenuItem
        to="/statistics-by-day"
        active={pathName === 'statistics-by-day'}
        startIcon={<Icon type={pathName === 'statistics-by-day' ? 'homeActive' : 'home'} />}
    >
        Статистика по дням
    </MenuItem>
)

export const StatisticsReportsMenuItem = ({ pathName }) => (
    <MenuItem
        to="/statistics-reports"
        active={pathName === 'statistics-reports'}
        startIcon={<Icon type={pathName === 'statistics-reports' ? 'statisticActive' : 'statistic'} />}
    >
        Отчеты
    </MenuItem>
)

const rentalSection = () => window.location.pathname.split('/')[2] || 'dashboard';

export const RentalDashboardMenuItem = ({ pathName }) => (
    <MenuItem
        to="/rental/dashboard"
        active={pathName === 'rental' && rentalSection() === 'dashboard'}
        startIcon={<Icon type={pathName === 'rental' && rentalSection() === 'dashboard' ? 'homeActive' : 'home'} />}
    >
        Дашборд
    </MenuItem>
)

export const RentalLocationsMenuItem = ({ pathName }) => (
    <MenuItem
        to="/rental/locations"
        active={pathName === 'rental' && rentalSection() === 'locations'}
        startIcon={<Icon type={pathName === 'rental' && rentalSection() === 'locations' ? 'mapMarkerActive' : 'mapMarker'} />}
    >
        Локации
    </MenuItem>
)

export const RentalDocumentsMenuItem = ({ pathName }) => (
    <MenuItem
        to="/rental/documents"
        active={pathName === 'rental' && rentalSection() === 'documents'}
        startIcon={<Icon type="statistic" />}
    >
        Документы
    </MenuItem>
)

export const RentalVehiclesMenuItem = ({ pathName }) => (
    <MenuItem
        to="/rental/vehicles"
        active={pathName === 'rental' && rentalSection() === 'vehicles'}
        startIcon={<Icon type="stations" />}
    >
        Автопарк
    </MenuItem>
)

export const RentalRentalsMenuItem = ({ pathName }) => (
    <MenuItem
        to="/rental/rentals"
        active={pathName === 'rental' && rentalSection() === 'rentals'}
        startIcon={<Icon type="statistic" />}
    >
        Аренды
    </MenuItem>
)

export const RentalCalendarMenuItem = ({ pathName }) => (
    <MenuItem
        to="/rental/calendar"
        active={pathName === 'rental' && rentalSection() === 'calendar'}
        startIcon={<Icon type="statistic" />}
    >
        Календарь
    </MenuItem>
)

export const RentalClientsMenuItem = ({ pathName }) => (
    <MenuItem
        to="/rental/clients"
        active={pathName === 'rental' && rentalSection() === 'clients'}
        startIcon={<Icon type="statistic" />}
    >
        Клиенты
    </MenuItem>
)

export const RentalPaymentOperationsMenuItem = ({ pathName }) => (
    <MenuItem
        to="/rental/payment-operations"
        active={pathName === 'rental' && rentalSection() === 'payment-operations'}
        startIcon={<Icon type="statistic" />}
    >
        Платёжные операции
    </MenuItem>
)

export const RentalMapMenuItem = ({ pathName }) => (
    <MenuItem
        to="/rental/map"
        active={pathName === 'rental' && rentalSection() === 'map'}
        startIcon={<Icon type={pathName === 'rental' && rentalSection() === 'map' ? 'mapActive' : 'map'} />}
    >
        Карта автомобилей
    </MenuItem>
)

export const RentalSettingsMenuItem = ({ pathName }) => (
    <MenuItem
        to="/rental/settings"
        active={pathName === 'rental' && rentalSection() === 'settings'}
        startIcon={<Icon type={pathName === 'rental' && rentalSection() === 'settings' ? 'settingsActive' : 'settings'} />}
    >
        Настройки проката
    </MenuItem>
)
